import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  careerFields: [],
};

const manageDetailsSlice = createSlice({
  name: "manageDetails",
  initialState,
  reducers: {
    setCareerFields: (state, action) => {
      state.careerFields = action.payload;
    },
    clearCareerFields: (state) => {
      state.careerFields = {}; // Clear the selected or editing invoice
    },
  },
});

export const { setCareerFields, clearInvoiceData } = manageDetailsSlice.actions;

export default manageDetailsSlice.reducer;
